<div class="locked-staking-final-reminder wrapper">
	<div class="content">
		<div class="title">{{ "locked_staking_eth_final_reminder_title" | translate }}</div>
		<div class="description">{{ "locked_staking_eth_final_reminder_description" | translate }}</div>
		<div class="disclaimer">{{ "locked_staking_eth_final_reminder_disclaimer" | translate }}</div>
	</div>
	<div class="buttons">
		<bp-button (click)="onButtonClick.emit()" fluid size="large" variant="special">{{
			"locked_staking_eth_final_reminder_button" | translate
		}}</bp-button>
	</div>
</div>
